import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M10.5 10.421a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666ZM4.315 17.846v-1.667c0-.884.435-1.732 1.208-2.357.773-.625 1.822-.976 2.915-.976h4.123c1.094 0 2.143.35 2.916.976.773.625 1.207 1.473 1.207 2.357v1.667",
      stroke: "currentColor",
      strokeWidth: 1.6,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))
  }));
};
export default SvgUser;